var _defs, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 315.35 305.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 156.72,
    y1: 259,
    x2: 159.63,
    y2: 341.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 67.7,
    y1: 231.63,
    x2: 64.79,
    y2: 116.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 256,
    y1: 215.77,
    x2: 254.06,
    y2: 143.58,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 154.93,
    y1: 238.45,
    x2: 159.46,
    y2: 81.77,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.11 206.24c20.68 9.09 44.07 8.95 66.66 8.65 11.85-.15 24.11-.39 34.9-5.3 15-6.83 24.74-21.49 37.9-31.41 15.11-11.41 34.45-16.33 49.1-28.32a63.39 63.39 0 001.63-96.76c-7.75-6.78-17-11.57-26.17-16.28l-46.05-23.7c-10.79-5.55-21.86-11.19-33.9-12.7-10.16-1.27-20.44.49-30.37 2.76-28.3 6.4-56.38 17.43-77.14 37.62-17.86 17.4-29.52 40.77-49.06 56.26-5 3.95-10.54 7.44-14.18 12.66-13.1 18.81.17 42.84 17.19 52.48 23.57 13.34 44.78 33.19 69.49 44.04z",
    fill: "#4b39ef",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.68,
    cy: 286.11,
    rx: 157.68,
    ry: 19.48,
    fill: "#4b39ef"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.68,
    cy: 286.11,
    rx: 157.68,
    ry: 19.48,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3 95.8a26.4 26.4 0 00-20.18-4 7.65 7.65 0 00-3.48 1.49c-2.37 2-2 5.72-2.63 8.78-.77 3.77-3.3 7-4.21 10.72a24.15 24.15 0 00-.09 8.48 139.76 139.76 0 007.91 32.42l-11 144.91s11.25 1.82 34.07 3.64l2.42-138z",
    fill: "#eea886"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M58.79 180.31l14.57 58.92v-84.98l-6.48-19.26-8.09 45.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.32 97.04a26.42 26.42 0 0120.18-3.92 7.8 7.8 0 013.49 1.49c2.36 2 2 5.72 2.62 8.79.78 3.77 3.31 7 4.22 10.72a23.86 23.86 0 01.08 8.47 139.12 139.12 0 01-7.9 32.42l10.95 142.89s-12.25 2.06-34.14 4.13l-2.35-136.48z",
    fill: "#eea886"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M263.7 176.1l-5.17 26.55-11.01 23.95-.97-52.12 17.15 1.62z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.64,
    y: 48.4,
    width: 211.71,
    height: 133.37,
    rx: 8.37,
    fill: "#4b39ef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.64,
    y: 48.4,
    width: 211.71,
    height: 133.37,
    rx: 8.37,
    fill: "url(#d)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.64,
    y: 43.05,
    width: 211.71,
    height: 133.37,
    rx: 8.37,
    fill: "#4b39ef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.39 98.65c3.37-3.74 3.37-3.74 7.18-8.22l16.23-19a75.55 75.55 0 007-8.9h15.33a109.89 109.89 0 00-.59 12.41v24.31h2.17a52 52 0 007.4-.6v13.62a59.12 59.12 0 00-7.33-.45h-2.24v3.74a53.39 53.39 0 00.59 9.2h-15.4a66.1 66.1 0 00.59-9.35v-3.61h-21.2c-4.87 0-7 .07-9.73.29zm31-7.92c0-3.37.15-7.48.45-10.77-1.5 2.09-2.62 3.59-4.64 6.13L87.25 99.4h15.11zm36.09 28.42a23.66 23.66 0 01-5.46-8.3 49.74 49.74 0 01-2.92-17.13c0-7.86 1.87-16 4.72-20.72 4.56-7.63 12.34-11.82 21.76-11.82 7.26 0 13.62 2.47 18.18 7a23.53 23.53 0 015.46 8.3 49.62 49.62 0 012.92 17.2c0 7.86-1.87 16.09-4.71 20.8-4.49 7.48-12.35 11.67-21.85 11.67-7.33-.04-13.53-2.44-18.1-7zm7-26c0 13.39 3.81 20.27 11.22 20.27s11.07-6.73 11.07-20c-.04-12.87-3.96-19.62-11.19-19.62-7.03 0-11.14 7.13-11.14 19.32zm41.54 5.5c3.37-3.74 3.37-3.74 7.18-8.22l16.24-19a75.28 75.28 0 006.95-8.9h15.34a107.51 107.51 0 00-.6 12.41v24.31h2.17a52 52 0 007.4-.6v13.62a59.12 59.12 0 00-7.33-.45h-2.24v3.74a52.27 52.27 0 00.6 9.2h-15.41a65.93 65.93 0 00.6-9.35v-3.61h-21.17c-4.86 0-7 .07-9.73.29zm31-7.92c0-3.37.15-7.48.45-10.77-1.5 2.09-2.62 3.59-4.64 6.13L202.88 99.4h15.11zM72.11 146.67a22.9 22.9 0 013.81-.3 6.33 6.33 0 014.32 1.28 4.16 4.16 0 011.35 3.22 4.51 4.51 0 01-1.19 3.29 6.37 6.37 0 01-4.71 1.69 6.44 6.44 0 01-1.59-.14v6.17h-2zm2 7.42a6.35 6.35 0 001.64.16c2.4 0 3.86-1.16 3.86-3.29s-1.44-3-3.63-3a8.36 8.36 0 00-1.87.16zm10.7 2.95l-1.6 4.84h-2l5.22-15.39h2.38l5.25 15.39h-2.12l-1.64-4.84zm5-1.55l-1.51-4.43c-.34-1-.57-1.92-.8-2.81-.22.91-.48 1.85-.77 2.78l-1.51 4.46zm17.88 5.7a14.31 14.31 0 01-4.73.85 7.23 7.23 0 01-7.9-7.77c0-4.59 3.17-7.94 8.33-7.94a9.48 9.48 0 013.84.71l-.48 1.62a7.9 7.9 0 00-3.4-.66c-3.75 0-6.19 2.33-6.19 6.18s2.35 6.22 5.94 6.22a6.44 6.44 0 002.65-.42v-4.58h-3.13v-1.6h5.07zm11-6.53h-6v5.55h6.67v1.67h-8.66v-15.39h8.32v1.67h-6.31v4.86h6zm8.12 7.22v-15.39h2.17l4.93 7.78a45.68 45.68 0 012.77 5c-.18-2-.23-3.92-.23-6.32v-6.44h1.88v15.39h-2l-4.89-7.81a49.59 49.59 0 01-2.88-5.14h-.07c.12 1.95.16 3.8.16 6.35v6.58zm28.17-7.86c0 5.3-3.22 8.11-7.15 8.11s-6.92-3.15-6.92-7.81c0-4.89 3-8.08 7.15-8.08s6.92 3.22 6.92 7.78zm-11.94.25c0 3.29 1.78 6.24 4.91 6.24s4.93-2.9 4.93-6.4c0-3.05-1.6-6.25-4.91-6.25s-4.93 3.04-4.93 6.41zm16.87-6.09h-4.68v-1.69h11.4v1.69h-4.71v13.7h-2zm13.27-1.69h8.29v1.67h-6.3v5.11h5.82v1.64h-5.82v7h-2zm24.27 7.53c0 5.3-3.22 8.11-7.14 8.11-4.07 0-6.92-3.15-6.92-7.81 0-4.89 3-8.08 7.14-8.08s6.92 3.22 6.92 7.78zm-11.94.25c0 3.29 1.78 6.24 4.91 6.24s4.93-2.9 4.93-6.4c0-3.05-1.6-6.25-4.91-6.25s-4.93 3.04-4.93 6.41zm16.51-7.78v9.11c0 3.45 1.53 4.91 3.59 4.91 2.28 0 3.74-1.51 3.74-4.91v-9.11h2v9c0 4.73-2.49 6.67-5.82 6.67-3.15 0-5.53-1.8-5.53-6.58v-9.06zm12.79 15.39v-15.39h2.17l4.93 7.78a43.88 43.88 0 012.76 5h.05c-.18-2-.23-3.92-.23-6.32v-6.44h1.87v15.39h-2l-4.88-7.81a47.8 47.8 0 01-2.88-5.14h-.07c.11 1.95.16 3.8.16 6.35v6.58zm15-15.19a28.85 28.85 0 014.23-.32c2.85 0 4.89.67 6.23 1.92a7.1 7.1 0 012.17 5.53 8.12 8.12 0 01-2.21 6c-1.44 1.44-3.82 2.22-6.81 2.22a30.75 30.75 0 01-3.61-.24zm2 13.61a11.5 11.5 0 002 .12c4.25 0 6.55-2.38 6.55-6.53 0-3.63-2-5.94-6.23-5.94a10.79 10.79 0 00-2.33.21z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.61 94.05a5.48 5.48 0 012.12 1.87 6.69 6.69 0 01.63 3l.3 6.45a6.53 6.53 0 01-.37 3.14 2.27 2.27 0 01-2.58 1.36 9.69 9.69 0 01-.83 7.59 6.06 6.06 0 00-.75 1.56 5.79 5.79 0 00.1 2 11.49 11.49 0 01-2.67 9.09 4.07 4.07 0 01-1.18 1 5 5 0 01-1.88.4l-2.94.25a1 1 0 01-1.31-.89 65.62 65.62 0 01-3-21.91 63 63 0 011.34-11.12c.47-2.14 1.39-5.4 3.68-6.27 2.96-1.04 6.78 1.01 9.34 2.48zm193.12 0a5.48 5.48 0 00-2.12 1.87 6.69 6.69 0 00-.63 3l-.3 6.45a6.53 6.53 0 00.37 3.14 2.27 2.27 0 002.58 1.36 9.73 9.73 0 00.82 7.59 5.78 5.78 0 01.76 1.56 5.57 5.57 0 01-.11 2 11.54 11.54 0 002.68 9.09 4.07 4.07 0 001.18 1 5 5 0 001.88.4l2.97.29a1 1 0 001.31-.89 65.62 65.62 0 003-21.91 62.11 62.11 0 00-1.35-11.12c-.46-2.14-1-4.82-3.27-5.69-2.99-1.09-7.21.39-9.77 1.86z",
    fill: "#eea886"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4b030e4d5d8a72707e3d2bf5a0605252.svg";
export { ForwardRef as ReactComponent };